<template>
  <div id="privacy-page" class="body-landing">
    <AnimatedAiBackground />
    <section class="legal-content">
      <div class="container">
        <div class="document-container">
          <router-link class="legal-back-link" :to="{ name: 'landing' }">
            <i class="fas fa-arrow-left" aria-hidden="true"></i>
            Volver al inicio
          </router-link>
          <div class="document-header">
            <router-link class="redirect" to="/">
              <img
                src="/landing/logo-sofia-web.png"
                alt="Sofia"
                class="logo-con"
                style="width: 300px"
              />
            </router-link>
            <h1>Política de Privacidad</h1>
            <p>
              Esta política describe cómo Agente Sofia recopila, utiliza y
              comparte su información personal cuando utiliza nuestros
              servicios.
            </p>
          </div>
          <div class="document-content">
            <h2>Información que Recopilamos</h2>
            <p>
              Recopilamos varios tipos de información para proporcionar y
              mejorar nuestros servicios:
            </p>

            <h3>Información personal</h3>
            <p>
              Al registrarse para una cuenta, podemos solicitar cierta
              información de identificación personal, que incluye pero no se
              limita a:
            </p>
            <ul>
              <li>Nombre completo</li>
              <li>Dirección de correo electrónico</li>
              <li>Número de teléfono</li>
              <li>Información de la empresa</li>
              <li>Dirección de facturación</li>
            </ul>

            <h3>Datos de uso</h3>
            <p>
              Recopilamos información sobre cómo se accede y se utiliza el
              Servicio. Estos Datos de Uso pueden incluir información como:
            </p>
            <ul>
              <li>Dirección IP de su computadora</li>
              <li>Tipo de navegador y versión</li>
              <li>Páginas de nuestro servicio que visita</li>
              <li>Fecha y hora de su visita</li>
              <li>Tiempo dedicado a esas páginas</li>
            </ul>

            <h2>Cómo Utilizamos Su Información</h2>
            <p>Utilizamos la información recopilada para diversos fines:</p>
            <ul>
              <li>Proporcionar, operar y mantener nuestro servicio</li>
              <li>Mejorar, personalizar y expandir nuestro servicio</li>
              <li>Comprender y analizar cómo utiliza nuestro servicio</li>
              <li>
                Desarrollar nuevos productos, servicios, características y
                funcionalidades
              </li>
              <li>
                Comunicarnos con usted directamente o a través de nuestros
                socios
              </li>
              <li>
                Enviarle actualizaciones y otra información relacionada con el
                servicio
              </li>
            </ul>

            <h2>Divulgación de Su Información</h2>
            <p>
              Podemos divulgar su información personal en las siguientes
              situaciones:
            </p>
            <ul>
              <li>
                <strong>Proveedores de servicios:</strong> Podemos compartir su
                información personal con proveedores de servicios para
                monitorear y analizar el uso de nuestro servicio.
              </li>
              <li>
                <strong>Cumplimiento de la ley:</strong> Podemos divulgar su
                información personal cuando así lo exija la ley o en respuesta a
                solicitudes válidas de autoridades públicas.
              </li>
              <li>
                <strong>Protección de derechos:</strong> Podemos divulgar su
                información personal cuando creemos de buena fe que dicha acción
                es necesaria para proteger los derechos de nuestra empresa.
              </li>
            </ul>

            <h2>Seguridad de Sus Datos</h2>
            <p>
              La seguridad de sus datos es importante para nosotros, pero
              recuerde que ningún método de transmisión por Internet o método de
              almacenamiento electrónico es 100% seguro. Si bien nos esforzamos
              por utilizar medios comercialmente aceptables para proteger sus
              datos personales, no podemos garantizar su seguridad absoluta.
            </p>

            <h2>Enlaces a Otros Sitios</h2>
            <p>
              Nuestro servicio puede contener enlaces a otros sitios que no son
              operados por nosotros. Si hace clic en un enlace de un tercero,
              será dirigido al sitio de ese tercero. Le recomendamos
              encarecidamente que revise la Política de privacidad de cada sitio
              que visite.
            </p>

            <h2>Cambios a Esta Política de Privacidad</h2>
            <p>
              Podemos actualizar nuestra Política de Privacidad de vez en
              cuando. Le notificaremos cualquier cambio publicando la nueva
              Política de Privacidad en esta página.
            </p>
            <p>
              Se le aconseja que revise esta Política de Privacidad
              periódicamente para cualquier cambio. Los cambios a esta Política
              de Privacidad son efectivos cuando se publican en esta página.
            </p>

            <h2>Contacto</h2>
            <p>
              Si tiene alguna pregunta sobre esta Política de Privacidad, puede
              contactarnos:
            </p>
            <ul>
              <li>Por correo electrónico: privacidad@sofia.ai</li>
              <li>
                Visitando esta página en nuestro sitio web:
                www.sofia.ai/contacto
              </li>
            </ul>

            <div class="last-updated">
              <p>Última actualización: 25/05/2025 — Versión 2.0</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <footer class="main-footer">
      <!--Widgets Section-->
      <div class="widgets-section">
        <div class="auto-container">
          <div class="row">
            <!--Footer Column-->
            <div class="footer-column">
              <div class="footer-widget about-widget">
                <h3 class="widget-title" style="z-index: 10">SOFIA</h3>
                <!-- <a class="center-logo" href="#start"> -->
                <router-link class="redirect center-logo" to="/">
                  <div class="logo-container">
                    <div class="logo" ref="logo">
                      <div class="logo-inner">
                        <img
                          style="width: 55px"
                          src="/landing/log-sof-icon.png"
                          alt="Sofia"
                        />
                      </div>
                    </div>
                    <!-- <ParticlesLayer :amount="150" /> -->
                  </div>
                </router-link>
                <!-- </a> -->
                <ul class="social-icon-two">
                  <li>
                    <a
                      href="https://www.linkedin.com/company/smart-sales-agent/"
                      target="_blank"
                    >
                      <i class="fab fa-linkedin"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.instagram.com/sofia_agente?igsh=MTIzdjBmcjVxbmk3eQ=="
                      target="_blank"
                    >
                      <i class="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a href="https://wa.me/584145038466" target="_blank">
                      <i class="fab fa-whatsapp"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <!--Footer Column-->
            <div class="footer-column">
              <div class="footer-widget">
                <h3 class="widget-title">Explorar</h3>
                <ul class="user-links">
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#start' }"
                      >Inicio</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#features' }"
                      >Características</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'landing', hash: '#how-it-works' }"
                      >¿Cómo funciona?</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#pricing' }"
                      >Precios</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#about' }"
                      >Acerca de</router-link
                    >
                  </li>
                  <li>
                    <router-link :to="{ name: 'landing', hash: '#contact' }"
                      >Contacto</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
            <!--Footer Column-->
            <div class="footer-column">
              <div class="footer-widget contact-widget">
                <h3 class="widget-title">Contacto</h3>
                <div class="widget-content">
                  <ul class="contact-info">
                    <li>
                      <i class="fa fa-envelope"></i>
                      <a href="mailto:contacto@agentesofia.com"
                        >contacto@agentesofia.com</a
                      >
                    </li>
                    <li>
                      <i class="fa fa-phone-square"></i>
                      <a href="tel:+584145038466">+58 414-5038466</a>
                    </li>
                    <li>
                      <i class="fab fa-whatsapp"></i>
                      <a href="https://wa.me/584145038466">WhatsApp</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--Footer Column-->
            <div class="footer-column">
              <div class="footer-widget">
                <h3 class="widget-title">Documentos Legales</h3>
                <ul class="user-links">
                  <li>
                    <router-link to="/privacy"
                      >Política de Privacidad</router-link
                    >
                  </li>
                  <li>
                    <router-link to="/terms"
                      >Términos y Condiciones</router-link
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--Footer Bottom-->
      <div class="footer-bottom">
        <div class="auto-container">
          <div class="inner-container">
            <div class="copyright-text">
              © Copyright 2025 por
              <router-link :to="{ name: 'landing', hash: '#start' }"
                >Agente Sofia</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import AnimatedAiBackground from "./AnimatedAiBackground.vue";

export default {
  name: "Privacy",
  components: {
    AnimatedAiBackground,
  },
};
</script>

<style lang="css">
.content-landing {
  max-width: 1200px;
  min-height: 0 !important;
  margin: 0 auto;
  position: relative;
  z-index: 2;
}
.title {
  font-size: 3rem;
  margin-bottom: 1rem;
}
.animate {
  animation: fadeInUp 1s ease forwards;
  animation-play-state: paused;
  opacity: 0;
}

.logo {
  position: absolute;
  animation: pulse 6s infinite ease-in-out;
  filter: drop-shadow(0 0 10px #00c8ff);
  transform-style: preserve-3d;
  transition: transform 1.5s ease;
  /* transform: translate(-50%, -50%); */
}

.logo-con {
  filter: drop-shadow(0 0 10px #00c8ff);
  transform-style: preserve-3d;
  transition: transform 1.5s ease;
}
/* Animaciones */

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Logo */
/* @keyframes pulse {
  0% {
    transform: scale(1) rotate(0deg);
    box-shadow: 0 0 50px rgba(0, 198, 255, 0.7);
  }
  50% {
    transform: scale(1.05) rotate(5deg);
    box-shadow: 0 0 70px rgba(0, 114, 255, 0.9);
  }
  100% {
    transform: scale(1) rotate(0deg);
    box-shadow: 0 0 50px rgba(0, 198, 255, 0.7);
  }
} */
@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.05);
    opacity: 0.8;
  }
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

@keyframes typing {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

@keyframes blink {
  50% {
    border-color: transparent;
  }
}
</style>

<style lang="scss" scoped>
.body-landing {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
  // background: linear-gradient(135deg, #052e6d, #0a4a9f);
  color: #ffffff;
  overflow-x: hidden;
}

.legal-content {
  opacity: 1 !important; /* Asegurar que el contenido es visible */
  transform: none !important;
  flex: 1;
  padding: 80px 0;
  z-index: 9999;
}

/* Mejorar contraste y legibilidad */
.document-container {
  background: rgba(0, 20, 40, 51%) !important; /* Fondo más oscuro */
  color: #e0f0ff !important; /* Color de texto más claro */

  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 50px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
  margin-bottom: 50px;
}

.document-content h2 {
  color: #4fc3f7 !important; /* Color más vibrante para títulos */
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  width: 100%;
}

/* Header */
.legal-header {
  background: rgba(0, 0, 0, 0.2);
  padding: 20px 0;
  position: sticky;
  top: 0;
  z-index: 1000;
  backdrop-filter: blur(10px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;

  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

h1,
h2,
h3,
h4,
h5,
h6,
.h1,
.h2,
.h3,
.h4,
.h5,
.h6 {
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif !important;
  color: #ffffff;
}

h1 {
  font-size: 5rem;
  margin-bottom: 20px;
  line-height: 1.1;
  font-weight: 800;
  text-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

h2 {
  font-size: 2.5rem;
  margin-bottom: 30px;
  font-weight: 700;
  position: relative;
}

h2:after {
  content: "";
  position: absolute;
  bottom: -10px;
  left: 0;
  width: 60px;
  height: 4px;
  background: #28a9e0;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

h3 {
  font-weight: bold;
}

.widget-title {
  font-size: 1.5rem;
  margin-bottom: 25px;
  position: relative;
  padding-bottom: 15px;
}

.widget-title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 2px;
  background: #28a9e0;
}

p {
  font-size: 1.5rem;
  line-height: 1.8;
  max-width: 700px;
  margin-bottom: 30px !important;
}

.document-header {
  text-align: center;
  margin-bottom: 50px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.document-header h1 {
  font-size: 2.8rem;
  margin-bottom: 20px;
  color: #28a9e0;
}

.document-header p {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  max-width: 800px;
  margin: 0 auto;
}

.document-content {
  line-height: 1.8;
}

.document-content h2 {
  font-size: 1.8rem;
  margin: 40px 0 20px;
  color: #28a9e0;
  position: relative;
  padding-left: 20px;
}

.document-content h2::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 60%;
  width: 5px;
  background: #28a9e0;
  border-radius: 5px;
}

.document-content h3 {
  font-size: 1.4rem;
  margin: 30px 0 15px;
  color: #1a7bbd;
}

.document-content p {
  margin-bottom: 20px;
  font-size: 1.05rem;
}

.document-content ul {
  padding-left: 30px;
  margin-bottom: 30px;
}

.document-content li {
  margin-bottom: 12px;
  position: relative;
}

.document-content li::before {
  content: "•";
  color: #28a9e0;
  font-size: 1.5rem;
  position: absolute;
  left: -20px;
  top: -3px;
}

.last-updated {
  text-align: right;
  font-style: italic;
  margin-top: 40px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.95rem;
}

/* Footer */
.main-footer {
  position: relative;
  background: linear-gradient(
    145deg,
    rgba(2, 13, 34, 0.98),
    rgba(5, 46, 109, 0.96)
  );
  color: #ffffff;
  padding: 80px 0 0;
  overflow: hidden;
  margin-top: auto;
  border-top: 1px solid rgba(79, 195, 247, 0.22);
  box-shadow: 0 -24px 60px rgba(0, 0, 0, 0.22);
}

.main-footer .bg-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  opacity: 0.1;
}

.widgets-section {
  position: relative;
  z-index: 2;
}

.auto-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
}

.footer-column {
  padding: 0 15px;
  margin-bottom: 40px;
  flex: 1 1 220px;
  min-width: 220px;
}

.footer-widget {
  margin-bottom: 40px;
}

/* .about-widget .logo {
    margin-bottom: 20px;
}

.about-widget .logo img {
    max-width: 200px;
} */

.about-widget .text {
  margin-bottom: 25px;
  line-height: 1.7;
  font-size: 1rem;
  max-width: 350px;
}

.social-icon-two {
  display: flex;
  gap: 15px;
  list-style: none;
  padding: 0;
  justify-content: center;
}

.social-icon-two a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  color: white;
  font-size: 18px;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.social-icon-two a:hover {
  background: #28a9e0;
  transform: translateY(-3px);
}

.user-links {
  list-style: none;
  padding: 0;
}

.user-links li {
  margin-bottom: 12px;
}

.user-links li a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  font-size: 1.05rem;
}

.user-links li a:hover {
  color: #28a9e0;
  padding-left: 5px;
}

.contact-info {
  list-style: none;
  padding: 0;
}

.contact-info li {
  margin-bottom: 15px;
  display: flex;
  align-items: flex-start;
}

.contact-info li i {
  font-size: 1.2rem;
  margin-right: 15px;
  color: #28a9e0;
  min-width: 20px;
}

.contact-info li a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.contact-info li a:hover {
  color: #28a9e0;
}

.footer-bottom {
  position: relative;
  background: rgba(0, 7, 24, 0.5);
  z-index: 999;
  padding: 25px 0;
  text-align: center;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.legal-back-link {
  width: fit-content;
  margin-bottom: 24px;
  padding: 10px 14px;
  display: inline-flex;
  align-items: center;
  gap: 9px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.08);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 600;
  transition: all 0.25s ease;
}

.legal-back-link:hover {
  color: #ffffff;
  background: rgba(40, 169, 224, 0.25);
  transform: translateX(-3px);
}

.copyright-text {
  color: rgba(255, 255, 255, 0.7);
  font-size: 1rem;
}

.copyright-text a {
  color: #28a9e0;
  text-decoration: none;
}

/* Diseño del logo SofIA */
.logo-container {
  position: relative;
  margin: 0 auto 40px;
  width: 4rem;
  height: 4rem;
  perspective: 1000px;
}

.logo-inner {
  position: absolute;
  // width: 70%;
  // height: 70%;
  // background: rgba(255, 255, 255, 0.1);
  // border: 2px solid rgba(255, 255, 255, 0.2);
  // border-radius: 50%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  backdrop-filter: blur(5px);
}
</style>
